














import VueOptions from '@utils/VueOptions'

settings = 
  name: 'AudiencePartnershipResourceListItem'
  
  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      topOrgName: ->
        @item.supplier.top_org?.name || @item.supplier.name

export default VueOptions.vue settings
